/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 에디터가 기본으로 제공하는 내장 툴 클래스들의 레지스트리를 정의한다.
 *
 * @file /src/rootin/base/Tools.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 17.
 */
import { Tool } from '@rootin/base/Tool';
import { Bold } from '@rootin/tools/bold/Bold';
import { Color } from '@rootin/tools/color/Color';
import { Separator } from '@rootin/tools/separator/Separator';

export type { Tool };

export type ToolClass<T extends Tool = Tool> = (new () => T) & typeof Tool;

/**
 * 내장 툴 클래스 목록
 */
const registry: ToolClass[] = [Bold, Color];

export class Tools {
    /**
     * 툴바 구분자 클래스
     */
    static Separator = Separator;

    /**
     * 툴타입 문자열로 에디터 내장 툴 클래스를 가져온다.
     *
     * @param type - 툴타입
     * @returns 해당 툴 클래스
     */
    static get(type: string): ToolClass {
        const ToolClass = registry.find((ToolClass) => ToolClass.type === type);
        if (ToolClass === undefined) {
            throw new Error(`알 수 없는 툴타입입니다: ${type}`);
        }

        return ToolClass;
    }
}
